export const FAQ_SECTIONS = [
  {
    "title": "General Questions",
    "items": [
      {
        "question": "What is WeLinkJobs?",
        "answer": "WeLinkJobs is an online platform connecting job seekers with employers, offering a range of employment opportunities across various industries globally.",
        "defaultOpen": false
      },
      {
        "question": "How does WeLinkJobs work?",
        "answer": "WeLinkJobs allows employers to post job openings and job seekers to search for and apply to these jobs. The platform also offers resume-building tools, job alerts, and career resources.",
        "defaultOpen": true
      },
      {
        "question": "Is WeLinkJobs free to use?",
        "answer": "Yes, WeLinkJobs is free for job seekers. In the future, employers may be charged for posting premium jobs or accessing premium features.",
        "defaultOpen": false
      },
      {
        "question": "How do I create an account on WeLinkJobs?",
        "answer": "To create an account, click on the “Sign Up” button on the sign in page and fill out the required information, such as your name, email address, and password. Also, you can have a quick log in through “Sign in with Google or Apple option.",
        "defaultOpen": false
      },
      {
        "question": "Can I use WeLinkJobs without creating an account?",
        "answer": "You can browse job listings without an account, but you need to create one to apply for jobs, save job searches, or to explore additional features.",
        "defaultOpen": false
      },
      {
        "question": "What makes WeLinkJobs different from other job search platforms?",
        "answer": "WeLinkJobs focuses on personalized job recommendations, robust career resources, and a user-friendly interface designed to make job searching and hiring more efficient.",
        "defaultOpen": false
      },
      {
        "question": "Can I view employer reviews on WeLinkJobs?",
        "answer": "Yes, you can view reviews for employers left by users to help you make more informed decisions about potential employers.",
        "defaultOpen": false
      },
      {
        "question": "What should I do if I encounter a technical issue while using WeLinkJobs?",
        "answer": "Contact our customer support team via email or phone for assistance with any technical issues.",
        "defaultOpen": false
      }
    ]
  },
  {
    "title": "Job Seekers FAQs",
    "items": [
      {
        "question": "How do I search for jobs on WeLinkJobs?",
        "answer": "Use the job search feature at the portal/app to enter job titles, keywords, or company names, and filter results by location, industry, or job type.",
        "defaultOpen": false
      },
      {
        "question": "How do I apply for a job on WeLinkJobs?",
        "answer": "Once you find a job you’re interested in, click on the job title to view the details, and click “Apply Now” to submit your application.",
        "defaultOpen": true
      },
      {
        "question": "Can I upload my resume to WeLinkJobs?",
        "answer": "Yes, you can upload your resume by logging into your account and clicking on the “My Resume” section to upload a file or create a resume using our builder tool.",
        "defaultOpen": false
      },
      {
        "question": "What types of jobs can I find on WeLinkJobs?",
        "answer": "WeLinkJobs offers a wide range of job types, including full-time, part-time, internships, remote positions, and freelance opportunities across various industries.",
        "defaultOpen": false
      },
      {
        "question": "What should I do if I am not receiving job alerts?",
        "answer": "Check your spam or junk email folder first. If job alerts are still missing, ensure your email address is correct in your account settings.",
        "defaultOpen": false
      },
      {
        "question": "Can I access my WeLinkJobs account from multiple devices?",
        "answer": "Yes, you can access your account from multiple devices, including computers, tablets, and smartphones, to manage your job search on the go.",
        "defaultOpen": false
      },
      {
        "question": "Can I apply for multiple jobs at once?",
        "answer": "Yes, you can apply for multiple jobs, but each application needs to be submitted separately.",
        "defaultOpen": false
      },
      {
        "question": "Can I apply for jobs outside my country using WeLinkJobs?",
        "answer": "Yes, you can search and apply for international job opportunities. Make sure to check visa and work permit requirements for the country where you are applying.",
        "defaultOpen": false
      },
      {
        "question": "How do I track my job applications?",
        "answer": "You can track your applications by logging into your account and going to the “Manage Job”” section, where you’ll see the status of each application.",
        "defaultOpen": false
      },
      {
        "question": "What should I do if I forget my password?",
        "answer": "Click on the “Forgot Password” link on the login page, enter your email address, and follow the instructions to reset your password.",
        "defaultOpen": false
      },
      {
        "question": "Can I deactivate or delete my WeLinkJobs account?",
        "answer": "Yes, you can deactivate or delete your account by contacting customer support or through the account settings page.",
        "defaultOpen": false
      },
      {
        "question": "How do I update my profile information?",
        "answer": "Log in to your account and navigate to “My Profile” to edit and update your personal information, resume, and preferences.",
        "defaultOpen": false
      },
      {
        "question": "What should I do if I find a job posting that looks suspicious?",
        "answer": "Please report any suspicious job postings to our support team using the “Report Job” button on the job listing page.",
        "defaultOpen": false
      },
      {
        "question": "Can I hide my resume from certain employers?",
        "answer": "Yes, you can choose to make your resume private or limit visibility to specific employers by adjusting your privacy settings.",
        "defaultOpen": false
      },
      {
        "question": "How can I improve my chances of getting hired?",
        "answer": "Enhance your profile with a professional resume, keep your information up to date, and apply to jobs that match your skills and experience.",
        "defaultOpen": false
      },
      {
        "question": "Do I need a cover letter for every job application?",
        "answer": "While not mandatory for all jobs, including a cover letter can enhance your application by providing more context about your skills and interest in the position.",
        "defaultOpen": false
      },
      {
        "question": "What are job recommendations, and how are they generated?",
        "answer": "Job recommendations are tailored job listings based on your profile information, previous searches, and job applications.",
        "defaultOpen": false
      }
    ]
  },
  {
    "title": "Employers FAQs",
    "items": [
      {
        "question": "Can I create a company profile on WeLinkJobs?",
        "answer": "Yes, creating a company profile helps showcase your brand and attract more candidates. You can add your company’s logo, description, and open positions.",
        "defaultOpen": false
      },
      {
        "question": "How do I post a job on WeLinkJobs?",
        "answer": "Log in to your employer account, click “Post a Job,” fill in the job details, and choose your preferred posting plan.",
        "defaultOpen": true
      },
      {
        "question": "Are there any fees for posting jobs on WeLinkJobs?",
        "answer": "WeLinkJobs offers both free and premium job posting options, with fees for premium features like enhanced visibility and targeted advertising.",
        "defaultOpen": false
      },
      {
        "question": "How do I manage my job postings?",
        "answer": "Go to your company page jobs tab to view, edit, or delete job postings and manage applications through the Job Notifications menu.",
        "defaultOpen": false
      },
      {
        "question": "Can I schedule interviews through WeLinkJobs?",
        "answer": "Yes, employers can use the built-in interview scheduling tool to arrange interviews with candidates directly through the platform.",
        "defaultOpen": false
      },
      {
        "question": "How do I contact a candidate directly?",
        "answer": "You can contact candidates directly through the messaging system on the platform before or after they have applied to your job listing.",
        "defaultOpen": false
      },
      {
        "question": "Can I repost expired job listings?",
        "answer": "Yes, expired job listings can be reposted from your company page (Jobs tab).",
        "defaultOpen": false
      },
      {
        "question": "How do I know if my job post was successful?",
        "answer": "You will receive an email confirmation once your job is successfully posted, and you can also view it in your company page (Jobs tab).",
        "defaultOpen": false
      },
      {
        "question": "How long will my job listing remain active?",
        "answer": "Job listings remain active for 30 days, but you can extend this period by using any valid plan.",
        "defaultOpen": false
      },
      {
        "question": "What types of jobs are not allowed to be posted on WeLinkJobs?",
        "answer": "We do not allow postings for jobs that are fraudulent, involve scams, or violate any local, state, or federal laws. Please refer to our job posting guidelines for more details.",
        "defaultOpen": false
      },
      {
        "question": "Can I edit my job postings after they are published?",
        "answer": "Yes, job postings can be edited at any time before expiration date from your company page.",
        "defaultOpen": false
      },
      {
        "question": "Can I view candidates' profiles before they apply for a job?",
        "answer": "Yes, you can browse the resume database to view candidates' profiles and invite suitable ones to apply for your job openings.",
        "defaultOpen": false
      }
    ]
  },
  {
    "title": "Technical and Support FAQs",
    "items": [
      {
        "question": "What should I do if I experience a technical issue with the website?",
        "answer": "For technical issues, please contact our support team through the “Help” section or by emailing info@welinkjobs.com.",
        "defaultOpen": false
      },
      {
        "question": "How do I change my email address on my account?",
        "answer": "Log in to your account, go to “Account Settings,” and update your email address in the designated field.",
        "defaultOpen": true
      },
      {
        "question": "Is my personal information safe on WeLinkJobs?",
        "answer": "Yes, we take data privacy seriously and use encryption and other security measures to protect your information. Please review our Privacy Policy for more details.",
        "defaultOpen": false
      },
      {
        "question": "Can I access WeLinkJobs on mobile devices?",
        "answer": "Yes, WeLinkJobs is accessible on both desktop and mobile devices, and we also have a mobile app available for download.",
        "defaultOpen": false
      },
      {
        "question": "What happens to my data if I delete my account?",
        "answer": "If you delete your account, your personal data will be removed in accordance with our data retention policy. For specific details, refer to our Privacy Policy.",
        "defaultOpen": false
      },
      {
        "question": "What internet browsers are compatible with WeLinkJobs?",
        "answer": "WeLinkJobs is compatible with the latest versions of Chrome, Firefox, Safari, and Edge.",
        "defaultOpen": false
      },
      {
        "question": "How do I report a technical issue or bug?",
        "answer": "Use the “Report a Problem” feature in the “Help” section or contact support directly at info@welinkjobs.com.",
        "defaultOpen": false
      },
      {
        "question": "Can I retrieve a deleted job application?",
        "answer": "Once an application is deleted, it cannot be retrieved. Please be cautious when managing your applications.",
        "defaultOpen": false
      },
      {
        "question": "Do you offer support in languages other than English?",
        "answer": "Currently, support is available in English, but we are working on expanding support to other languages in the future.",
        "defaultOpen": false
      },
      {
        "question": "How do I contact WeLinkJobs customer support?",
        "answer": "You can contact customer support via the “Contact Us” page on our website or by emailing info@welinkjobs.com.",
        "defaultOpen": false
      }
    ]
  }
];
